import { defineComponent, openBlock, createElementBlock, createVNode, unref, withCtx } from "vue";
import { DatePickerPrevTrigger, DatePickerViewTrigger, DatePickerRangeText, DatePickerNextTrigger } from "@ark-ui/vue/date-picker";
import ChevronLeftIcon from "../../../assets/icons/chevron-left.svg.js";
const _hoisted_1 = { class: "elfie-datepicker__header" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Header",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(DatePickerPrevTrigger), { class: "elfie-datepicker__nav-button" }, {
          default: withCtx(() => [
            createVNode(unref(ChevronLeftIcon), { class: "elfie-datepicker__icon elfie-datepicker__icon--chevron" })
          ]),
          _: 1
        }),
        createVNode(unref(DatePickerViewTrigger), { class: "elfie-datepicker__view-trigger" }, {
          default: withCtx(() => [
            createVNode(unref(DatePickerRangeText))
          ]),
          _: 1
        }),
        createVNode(unref(DatePickerNextTrigger), { class: "elfie-datepicker__nav-button" }, {
          default: withCtx(() => [
            createVNode(unref(ChevronLeftIcon), { class: "elfie-datepicker__icon elfie-datepicker__icon--chevron elfie-datepicker__icon--chevron-right" })
          ]),
          _: 1
        })
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Header.vue2.js.map
